export default "/fonts/vendor/@coreui/icons/CoreUI-Icons-Free.woff?7070e73f104dde775400296969eb53ce";